import { Dictionary } from '../../utils/types'

export const filterKeysToTranslationsMapper: Dictionary<string> = {
  email: 'form:Email',
  invitationDateFrom: 'dialogs:ProfileManagementAdvancedFilter:InvitationDateFrom',
  invitationDateTo: 'dialogs:ProfileManagementAdvancedFilter:InvitationDateTo',
  activationDateFrom: 'dialogs:ProfileManagementAdvancedFilter:ActivationDateFrom',
  activationDateTo: 'dialogs:ProfileManagementAdvancedFilter:ActivationDateTo',
  visibilityRoleId: 'dialogs:ProfileManagementAdvancedFilter:Visibility',
  permissionRoleId: 'dialogs:ProfileManagementAdvancedFilter:Permission',
  officeId: 'dialogs:ProfileManagementAdvancedFilter:Office'
}
